import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'limitResults' })
export class LimitResultsPipe implements PipeTransform {

  transform(value: any, limit: any): any {
    if (value && value.length > 0 && (value[0].hasOwnProperty('title')) && limit > 0) {
      const limitPerSection = Math.ceil(limit / value.length);
      return value.map(section => {
        return {...section, content: section.content.slice(0, limitPerSection)};
      });
    } else if (value && limit > 0) {
      return value.slice(0, limit);
    }
    return value;
  }

}
